import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {IntranetoldService} from '../../../api/intranetold.service'
import { Columns, Config, DefaultConfig, APIDefinition, API } from 'ngx-easy-table';
import {DocumentoMarketingDetalle, DocumentoMarting} from "./../../../model/ventaModel"
import { variableGlobal } from '../../../global.enum';
import {NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { StockComercialDetalleItemBodegaComponent } from './../stock-comercial/detalleArticuloBodega';
import { abreTablaGenericoComponent } from '../../app/query-mongo/abreTablaGenerico';
import { environment } from 'src/environments/environment';
import { string } from '@amcharts/amcharts4/core';

@Component({
  selector: 'app-selectedItemCode',
  templateUrl: './listaArticulo.html',
  styleUrls: ['./venta.component.sass']
})
export class listaArticuloComponent implements OnInit {

  constructor(
    public activeModal: NgbActiveModal,
    private _api: IntranetoldService,
    private modalService: NgbModal,
  ) { }

  @ViewChild('table', { static: true }) table: APIDefinition;
  public configuration: Config;
  public columns: Columns[];
  PriceList = 2;
  Encabezado:DocumentoMarting;
  tipoCambio:number;
  Currency:any;
  Detalle:DocumentoMarketingDetalle;
  condicionListaMateriales:string = "ListaMateriales"
  DefaultWhsCode: string = null;
  data:any;
  USD=0;
  EUR=0;

  async ngOnInit(): Promise<void> {
    await this.cargaInicial();
    await this.CargarMonedas();
    
  }

  @ViewChild('frmItemCode', { static: true }) frmItemCode: TemplateRef<any>;
  @ViewChild('frmPrice', { static: true }) frmPrice: TemplateRef<any>;
  @ViewChild('frmSerie', { static: true }) frmSerie: TemplateRef<any>;
  @ViewChild('frmLote', { static: true }) frmLote: TemplateRef<any>;
  @ViewChild('frmPriceOther', { static: true }) frmPriceOther: TemplateRef<any>;
  @ViewChild('frmDisponibleVenta', { static: true }) frmDisponibleVenta: TemplateRef<any>;

  async CargarMonedas(){
    this.USD = await this.GetRates("USD");
    this.EUR = await this.GetRates("EUR");
  }

  async cargaInicial()
  {

    
    
    

    if (this.Currency == 'CLP') {
      this.PriceList = 2
    }else if(this.Currency == 'USD'){
      this.PriceList = 3;
    }

    this.columns = [
      { key: 'ItemCode', title: "Artículo", cellTemplate: this.frmItemCode},
      { key: 'ItemName', title: 'Descripción' },
      { key: '', title: 'Disponible para venta', cssClass: { includeHeader: true, name: 'green-background' }, cellTemplate: this.frmDisponibleVenta},
      { key: 'OnHand', title: 'Stock' },
      { key: 'IsCommited', title: 'NV'},
      { key: 'Price', title: 'Precio', cellTemplate: this.frmPrice },
      { key: 'DISPONIBLE', title: 'Teórico' },
      { key: 'LOTE', title: 'Lote'},
      { key: 'ItmsGrpNam', title: 'Categoría'}
    ];
    this.configuration = {
      ...DefaultConfig,
      searchEnabled: true,
      detailsTemplate: false,
      paginationRangeEnabled: false,

      horizontalScroll: true,
      resizeColumn: true,
      orderEnabled: true,
      rowReorder:false,
      columnReorder:false,
      fixedColumnWidth: false,
      selectRow:false,

      paginationEnabled:true,
      //radio:true
      //infiniteScroll:true,
      //infiniteScrollThrottleTime: 10,
      //rows:10,

   };


    //cargaListaMateriales
    var data:any = await this._api.getQueryAll();
    var query:string = "";
    
    await data.objeto.forEach(element => {
      if (element.NOMBRE == this.condicionListaMateriales) {
        query = element.CONSULTA;
      }
    });
    

    query = query.replace("REEMPLAZA", this.PriceList.toString());

    if (environment.RUTA_API.includes("peru")) {}
    else{
      //query = query.replace(",T0.[U_IND_SWW]",",T0.[U_IND_SWW],[U_IND_TIPO]");
    }

    // Si hay bodega default, reemplazar stock total por stock de esa bodega
    if (this.DefaultWhsCode) {
      const whs = this.DefaultWhsCode.replace(/'/g, "''");
      query = query.replace(
        "T0.[OnHand]",
        "ISNULL((SELECT W.[OnHand] FROM OITW W WHERE W.[ItemCode] = T0.[ItemCode] AND W.[WhsCode] = '" + whs + "'), 0) AS [OnHand]"
      );
      query = query.replace(
        "T0.[IsCommited]",
        "ISNULL((SELECT W.[IsCommited] FROM OITW W WHERE W.[ItemCode] = T0.[ItemCode] AND W.[WhsCode] = '" + whs + "'), 0) AS [IsCommited]"
      );
      
    }

    if (this.Encabezado.Currency != "CLP") {
      query = query.replace("T2.[Price]", "T2.[Price], '" + this.Encabezado.Currency + "' AS [CurrencyOther], ROUND(T2.[Price] / " + this.tipoCambio + ", " + variableGlobal.DECIMALES_OTRA_MONEDA + ") AS [PriceOther]");

      if(this.Encabezado.ObjType=="540000006"|| this.Encabezado.ObjType=="22"){
        query = query.replace("T0.[SellItem] = 'Y'","T0.[PrchseItem] = 'Y'")
      }
    }

    


    data = await this._api.GetNotFileQuery(query);
    this.data = data.objeto;

    
    if(variableGlobal.ESTILO_EASY_TABLE)
    this.setClass(variableGlobal.ESTILO_EASY_TABLE);
  }

  private setClass(name: string): void {
    this.table.apiEvent({
      type: API.setTableClass,
      value: name,
    });
  }

  cerrar() {
    this.activeModal.close();
  }

  eventEmitted($event): void {
    //this.clicked = JSON.stringify($event);

    var data:any = $event.value.row;
    // || $event.event == "onClick"
    if ($event.event == "onDoubleClick") {

      
      
      this.Detalle.LineNum = -1;
      this.Detalle.VATLiable = data.VATLiable;
      this.Detalle.ItemCode = data.ItemCode;
      this.Detalle.Dscription = data.ItemName;
      this.Detalle.Factor1 = data.SalFactor1;
      this.Detalle.Factor2 = data.SalFactor2;
      this.Detalle.FrgnName = data.FrgnName;

      if(!data.Price)
      {
        data.Price=0;
      }

      this.Detalle.Price = data.Price.toFixed(variableGlobal.DECIMALES_CLP);
      this.Detalle.Disc = 0;
      this.Detalle.OnHand = data.OnHand;
      this.Detalle.WhsCode = data.DfltWH;
      this.Detalle.Currency = data.Currency
      this.Detalle.Quantity = 1;
      this.Detalle.ManSerNum = data.ManSerNum;
      this.Detalle.ManBtchNum = data.ManBtchNum;
      this.Detalle.PrecioOG = data.Price;
      this.Detalle.CurrencyOG = data.Currency;
      this.Detalle.SalUnitMsr = data.SalUnitMsr;
      this.Detalle.BuyUnitMsr = data.BuyUnitMsr;

      this.Detalle.UserFields = [
        {
          Field:"U_IND_TIPO",
          FieldType: "String",
          Value:data.U_IND_TIPO
        },
        {
          Field:"U_IND_WMS_ESTADO",
          FieldType: "String",
          Value:"T"
        },
        {
          Field:"U_IND_SWW",
          FieldType: "String",
          Value:data.U_IND_SWW
        },
      ];

      
      

      if (this.Encabezado.Currency != "CLP") {
        if(this.Encabezado.Currency != data.Currency)
        {
          if(!data.PriceOther){
            data.PriceOther=0;
          }
          this.Detalle.Price = data.PriceOther.toFixed(variableGlobal.DECIMALES_OTRA_MONEDA);
          this.Detalle.Currency = this.Encabezado.Currency;
        }else{
          this.Detalle.Price = data.Price.toFixed(variableGlobal.DECIMALES_OTRA_MONEDA);
        }

      }
      if(data.Currency!="CLP" && this.Encabezado.Currency=="CLP"){

        if(data.Currency == "USD"){
          this.Detalle.Price=data.Price * this.USD;
        }


      }
      
      if (this.Encabezado.ObjType == "17") {
        if (this.Detalle.ManBtchNum == "Y") {
          this.Detalle.ocultaLote = false;
        }
        if (this.Detalle.ManSerNum == "Y") {
          this.Detalle.ocultaSerie = false;
        }


      }

      
    }
    if ($event.event == "onDoubleClick") {


      this.Seleccionar();
    }

  }
  Seleccionar()
  {
    this.activeModal.close(this.Detalle);
  }

  AbrirDetalleItem(item)
  {
    let ngbModalOptions: NgbModalOptions = {
      backdrop : 'static',
      keyboard : false,
      size:"xl",
      modalDialogClass:variableGlobal.CLASS_MODAL_BG
    };
    const modalRef = this.modalService.open(StockComercialDetalleItemBodegaComponent, ngbModalOptions);
    modalRef.componentInstance.ItemCode = item.ItemCode;
    modalRef.componentInstance.modalReference = modalRef;
    modalRef.result.then((data) => {


    }, (reason) => {
      //this.editar(item);
    });
  }

  async abrirItemLote(item) {

    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      size: "xl",
      modalDialogClass: variableGlobal.CLASS_MODAL_BG
    };

    var queryConsulta: string;
    queryConsulta = await this.obtieneQueryMongo("VistaLotesBodega");

    queryConsulta = queryConsulta.replace("INPUTARTICULO", item.ItemCode);
    queryConsulta = queryConsulta.replace("INPUTBODEGA", item.WhsCode);

    const modalRef = this.modalService.open(abreTablaGenericoComponent, ngbModalOptions);
    modalRef.componentInstance.query = queryConsulta;
    modalRef.componentInstance.titulo = "Detalle lotes de articulo";
    modalRef.result.then();

  }

  async GetRates(Currency){
    var oRate=-1;

    if (Currency != "CLP") {
      var data:any = await this._api.getQueryAll();
      var query:string;
      await data.objeto.forEach(element => {
        if (element.NOMBRE == "tipoCambioTodo") {
          query = element.CONSULTA;
        }
      });

      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();

      var fechaStr:string = yyyy + "-" + mm + "-" + dd;
      //var fechaStr:string = "2023-09-10";
      query = query + " WHERE [RateDate] = '" + fechaStr + "' AND [Currency] = '" + Currency + "'";
      var data:any = await this._api.GetNotFileQuery(query);


      if (data.objeto.length > 0) {
        var Rate = data.objeto[0].Rate;
        if (Rate > 0) {
          oRate = Rate;
        }
      }
      if(oRate<0){
        oRate=1;
      }
    }
    else
    {
      oRate=1;
    }

    return oRate;
  }

  async obtieneQueryMongo(nombre) {
    var data: any = await this._api.getQueryAll();
    var query: string = "";
    await data.objeto.forEach(element => {
      if (element.NOMBRE == nombre) {
        query = element.CONSULTA;
      }
    });

    return query;
  }

}
